import { IconProps } from "@/components/Icons/index";

export const CloudLogo: React.FC<IconProps> = (props) => {
  return <img src="/assets/images/cloud.png" alt="cloud" {...props} />;
};

export const CloudLogoLight: React.FC<IconProps> = (props) => {
  return <img src="/assets/images/cloud-light.png" alt="cloud" {...props} />;
};
